module.exports = __webpack_public_path__ + "img/arrow.0b05a3ab.svg";